module.exports = __webpack_public_path__ + "img/02.6bba1f57.png";